import { Box } from 'monday-ui-react-core'
import { useNavigate, createSearchParams } from 'react-router-dom'
import React, { useContext } from 'react'
import { Col } from 'react-bootstrap'
import { Heading } from 'monday-ui-react-core'
import { StatementContext } from 'utils/context/StatementsContext'
import format from 'date-fns/format'
import { DocumentTypes } from './../../utils/Constants'

const StatementCard = ({ cardType, statementInfo }) => {
    const navigate = useNavigate()
    const {
        setCurrentSenderCompanyName,
        setCurrentDocumentDescription,
        setLastActivePage,
        setCanUploadFileCurrentCompany,
        setIsShowHeaderButton
    } = useContext(StatementContext)

    // Here we would set the state for the payouts and future different types
    const handleSenderCardClick = (senderNumber, documentType) => {
        setCurrentDocumentDescription(statementInfo.documentDescription)
        setCurrentSenderCompanyName(statementInfo.companyName)
        setLastActivePage('Sender')
        setCanUploadFileCurrentCompany(statementInfo.canUploadFile)
        // Navigate to correct path based on document type
        let route = '/product-balancing/sender/report';
        if (documentType === DocumentTypes.PAYOUT_STATEMENT)
        {
            setIsShowHeaderButton(false)
            route = '/payout/sender/report';
        } else {
            setIsShowHeaderButton(true)
        }
        
        navigate({
            pathname: route,
            search: createSearchParams({
                senderNumber,
            }).toString(),
        })
    }

    const handleReceiverCardClick = (documentType) => {
        setCurrentDocumentDescription(statementInfo.documentDescription)
        setLastActivePage('Receiver')
        setCurrentSenderCompanyName('')
        let route = '/product-balancing/receiver/report';
        if (documentType === DocumentTypes.PAYOUT_STATEMENT)
        {
            setIsShowHeaderButton(false)
            route = '/payout/receiver/report';
        }else {
            setIsShowHeaderButton(true)
        }
        navigate({
            pathname: route,
        })
    }

    const handleCardClick = () => {
        if (cardType === 'receiver') {
            handleReceiverCardClick(statementInfo.documentType)
        } else {
            handleSenderCardClick(
                statementInfo.senderNumber,
                statementInfo.documentType
            )
        }
    }

    const contentCard = () => {
        return (
            <div
                className={`statement-card ${cardType}-card justify-content-center align-items-center flex-column `}
                onClick={handleCardClick}
            >
                <div className="d-flex justify-content-center align-items-center flex-column mb-5">
                    {cardType === 'sender' && (
                        <p className="sender-name mt-2 mb-1">
                            {statementInfo.companyName}
                        </p>
                    )}
                    <Heading
                        value={statementInfo.amountStatementsCurrentMonth}
                        className="card-title"
                    />
                    <p className='date-text'>{`Statements ${format(new Date(), "LLL - yyyy")}`}</p>
                </div>
            </div>
        )
    }

    return (
        <Col xs={12} md={4} lg={4}>
            <Box
                className="box-card"
                border={Box.borders.DEFAULT}
                rounded={Box.roundeds.MEDIUM}
                marginTop={Box.marginTops.MEDIUM}
                padding={Box.paddingTops.SMALL}
            >
                {contentCard()}
            </Box>
        </Col>
    )
}

export default StatementCard
